import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { listeArticlesAll } from "../actions/articlesActions";
import "../ArticleListeStockNegative.css";

const ArticleListeStockNegative = ({ navigation }) => {
  const [search, setSearch] = useState("");
  const [artTab, setArtTab] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const aListe = useSelector((state) => state.articlesAll);
  const { articles, loading } = aListe;
  const Cl = useSelector((state) => state.client);
  const { client } = Cl;

  useEffect(() => {
    let unmounted = false;
    setArtTab([]);

    if (search === "") {
      dispatch(listeArticlesAll());
      setArtTab(articles);
    }

    if (!client) {
      navigate("/");
    }

    if (search !== "") {
      const filteredArticles = articles.filter((article) =>
        article.nom.toUpperCase().includes(search.toUpperCase())
      );
      setArtTab(filteredArticles);
    }

    return () => {
      unmounted = true;
    };
  }, [client, search, articles, dispatch, navigate]);

  const renderItem = (item, index) => {
    if (item?.num_stock >= 0) return null;

    return (
      <div
        key={index}
        className="article-stock-negative-item"
        style={{
          backgroundColor: item?.num_stock === 0 ? "white" : "#dcde66",
        }}
      >
        <div className="article-stock-negative-code">{item?.code_art}</div>
        <div className="article-stock-negative-name">{item?.nom}</div>
        <div className="article-stock-negative-stock">{item?.num_stock}</div>
      </div>
    );
  };

  return (
    <div className="article-stock-negative-container">
      <div className="article-stock-negative-search-container">
        <input
          type="text"
          placeholder="Chercher Article"
          className="article-stock-negative-search"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
      </div>

      {loading ? (
        <div className="loading-overlay">
          <div className="loading-text">Veuillez patienter...</div>
        </div>
      ) : (
        <div className="article-stock-negative-list-container">
          <div className="article-stock-negative-header">
            <div className="article-stock-negative-header-code">
              Code Article
            </div>
            <div className="article-stock-negative-header-name">Nom</div>
            <div className="article-stock-negative-header-stock">Stock</div>
          </div>

          <div className="article-stock-negative-items">
            {(artTab?.length !== 0 ? artTab : articles)?.map((item, index) =>
              renderItem(item, index)
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ArticleListeStockNegative;
